import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export default function({ app, softRedirect }) {
  const user = app.$client.profile;

  const isStepTwoRedirectCondition =
    !user.firstName ||
    !user.lastName ||
    !Object.keys(user.info).length ||
    !Object.keys(user.info.employment).length;
  const isStepThreeRedirectCondition = !Object.keys(user.info.primaryAddress).length;

  if (isStepTwoRedirectCondition) {
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_STEP_2));
  } else if (isStepThreeRedirectCondition) {
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_STEP_3));
  } else if (!user.hasApplications) {
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_STEP_4));
  }
}
